import { FeatureType } from "@/components/catalogues/FeatureCatalogue/FeatureType";
import { OperationType, getType } from "./OperationType";

export function setDisplayedOperations(type: any) {
  switch (type) {
    case FeatureType.String:
      return [
        getType(OperationType.Equal),
        getType(OperationType.NotEqual),
        getType(OperationType.Contains),
      ];
    case FeatureType.Boolean:
    case FeatureType.Enum:
    case FeatureType.DCatalogue:
    case FeatureType.Catalogue:
      return [getType(OperationType.Equal), getType(OperationType.NotEqual)];
    case FeatureType.Integer:
    case FeatureType.Decimal:
    case FeatureType.DateTime:
      return [
        getType(OperationType.Great),
        getType(OperationType.GreatOrEqual),
        getType(OperationType.Equal),
        getType(OperationType.Less),
        getType(OperationType.LessOrEqual),
        getType(OperationType.NotEqual),
      ];
    default:
      return [
        getType(OperationType.Great),
        getType(OperationType.GreatOrEqual),
        getType(OperationType.Equal),
        getType(OperationType.Less),
        getType(OperationType.LessOrEqual),
        getType(OperationType.NotEqual),
        getType(OperationType.Contains),
      ];
  }
}

export function setOperation(type: any) {
  switch (type) {
    case FeatureType.String:
      return getType(OperationType.Equal).id;
    case FeatureType.Boolean:
    case FeatureType.Enum:
    case FeatureType.DCatalogue:
    case FeatureType.Catalogue:
      return getType(OperationType.Equal).id;
    case FeatureType.Integer:
    case FeatureType.Decimal:
    case FeatureType.DateTime:
      return getType(OperationType.Great).id;
    default:
      return getType(OperationType.Great).id;
  }
}
